export const STRING_LENGTH_LIMIT = 50;
export const STRING_LENGTH_LIMIT_POSTFIX ='...';